export const servicesNames = {
  getLocations: "getLocations",
  getSelectLocations:"getSelectLocations",
  getSelectLocationsInDrawer:"getSelectLocationsInDrawer",
  getMetricsLocations:"getMetricsLocations",
  getSuggestions: "getSuggestions",
  getManagers: "getManagers",
  getManagersByBrands: "getManagersByBrands",
  getBrandNames: "getBrandNames",
  getDates: "getDates",
  getTypes: "getTypes",
  acceptSuggestion: "acceptSuggestion",
  dismissSuggestion: "dismissSuggestion",
  locationLeads: "locationLeads",
  escalate: "escalate",
  getBrandsLogo: "getBrandsLogo",
  getMonthlyUpdateBrands: "getMonthlyUpdateBrands",
  getBrandEmailOwners: "getBrandEmailOwners",
  getBrandsReports: "getBrandsReports",
  retryReportCreation: "retryReportCreation",
  getMonthlyBoardEmailReports: "getMonthlyBoardEmailReports",
  getFsms: "getFsms",
  getEmailReportById: "getEmailReportById",
  getInboxEmailReportsData: "getInboxEmailReportsData",
  getPerformanceUpdateDoneEmailReportsData: "getPerformanceUpdateDoneEmailReportsData",
  getDoneEmailReportsData: "getDoneEmailReportsData",
  getAllEmails: "getAllEmails",
  getEmailsStatistics: "getEmailsStatistics",
  getPauseAdData: "getPauseAdData",
  getCommunication: "getCommunication",
  searchLocations: "searchLocations",
  getBrands: "getBrands",
  getLocationsStatistics: "getLocationsStatistics",
  getSignature: "getSignature",
  refreshSignature: "refreshSignature",
  getLocationById: "getLocationById",
  getLogicSequenceData:"getLogicSequenceData",
};
